import { FC, useEffect, useState } from "react";
import DriverDetailsDriverPlanEntry from "../common/types/driver-details-plan-entry";
import driverDetailsPlanByTaxiPlanEntryFactory from "./common/driver-details-plan-by-taxi-plan-entry.factory";
import LoaderComponent from "../../../../../../common/components/loader/loader.component";
import DriverDetailsActiveRoutePlansContentComponent from "../driver-details-active-route-plans-content.component";
import { useAppContext } from "../../../../../../context/app.context";
import DriverDetailsCandidatureComponent from "../../candidature/driver-details-candidature.component";
import useAbort from "../../../../../../common/hooks/use-abort";
import useTaxiCorporationDriverPlan from "../../../../../../common/services/taxi-corporation/driver/plan/use-taxi-corporation-driver-plan";
import TaxiCorporationDriverPlanParams from "../../../../../../common/services/taxi-corporation/driver/plan/taxi-corporation-driver-plan-params";
import TaxiCorporationDriverPlan from "../../../../../../common/services/taxi-corporation/driver/plan/taxi-corporation-driver-plan";

type DriverDetailsPlanByTaxiProps = {
  driverUuid: string;
  isVisible: boolean;
};

const DriverDetailsPlanByTaxiComponent: FC<DriverDetailsPlanByTaxiProps> = (
  props,
) => {
  const { user } = useAppContext();

  const taxiCorporationDriverPlan = useTaxiCorporationDriverPlan();
  const taxiCorporationDriverPlanAbort = useAbort();

  const [planEntries, setPlanEntries] = useState<
    DriverDetailsDriverPlanEntry[]
  >([]);

  const onPlanFetchSuccess = (responseData: TaxiCorporationDriverPlan) => {
    const planEntries =
      driverDetailsPlanByTaxiPlanEntryFactory.createPlanEntries(
        responseData.entries,
      );

    setPlanEntries(planEntries);
  };

  const fetchPlan = () => {
    if (!props.driverUuid) {
      return;
    }

    const taxiCorporationUuid =
      user?.aspects.taxiOfficer?.taxiCorporationUuid ??
      user?.aspects.dealer?.taxiCorporationUuid!;

    const params: TaxiCorporationDriverPlanParams = {
      driverUuid: props.driverUuid,
      taxiCorporationUuid: taxiCorporationUuid,
    };

    taxiCorporationDriverPlan.load(
      params,
      taxiCorporationDriverPlanAbort.signal,
    );
  };

  useEffect(() => {
    if (!taxiCorporationDriverPlan.data) {
      return;
    }

    onPlanFetchSuccess(taxiCorporationDriverPlan.data);
  }, [taxiCorporationDriverPlan.data]);

  useEffect(() => {
    if (!props.isVisible || planEntries.length) {
      return;
    }

    fetchPlan();
  }, [props.isVisible, props.driverUuid]);

  if (taxiCorporationDriverPlan.isLoading && !planEntries.length) {
    return (
      <div className="driver_details_active_route_plans_loader_wrapper">
        <LoaderComponent type="primary" />
      </div>
    );
  }

  return (
    <>
      <DriverDetailsCandidatureComponent
        driverUuid={props.driverUuid}
        isVisible={props.isVisible}
        onAcceptCandidatureSuccess={fetchPlan}
        currentPlanEntries={planEntries}
      />
      <DriverDetailsActiveRoutePlansContentComponent
        driverUuid={props.driverUuid}
        planEntries={planEntries}
        refetchPlan={fetchPlan}
      />
    </>
  );
};

export default DriverDetailsPlanByTaxiComponent;
